import { memo, useState, useEffect, useMemo } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { BzLoader, } from '../../components';
import Overview from './Overview';
import CompanyInfo from './CompanyInfo';
import ContractDetails from './ContractDetails';
import Future from './Future';
import CorporateActions from './CorporateActions';
import Constituents from './Constituents';
import { useDispatch, useSelector } from 'react-redux';
import { MARKET_OVER_VIEW_TAB_KEYS, SCRIP_INSTRUMENTS, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import Analysis from '../Analysis'; // BT-112051 Creating tabs in Scrip Overview Analysis : ManasaB : 27/06/2023 
import { Recommendations, ZeroStates } from '../../containers';
import MarketMovement from './MarketMovement';
import { resetMarketOverview } from '../../redux/actions/marketOverview';
import IndicesKeyStats from './IndicesKeyStats';
import { getExchangeWiseScripInfo } from '../../redux/actions/orders';
import { getIndiceFutureData, resetIndiceOverView } from '../../redux/actions/indices';
import { clearOptionChainData } from '../../redux/actions/optionChain';
import OverviewChart from './OverviewChart';
import { scripWiseNewsData } from '../../redux/actions/news';
import NewsAnnouncements from './NewsAnnouncements';
import NewsDetailsModal from '../News/NewsDetailsModal';
import CorporateActionsDetails from './CorporateActionsDetails';
import { handleModal } from '../../redux/actions/modals';
import { boardMeeting, bonusData, bookClosure, buyBackData, dividendData, getAgmEgmData, rightsData, splitData } from '../../redux/actions/events';
import OptionChainGrid from '../OptionChain/OptionChainGrid';


const scripNewsPage = 10;

const MarketOverview = ({
    spinner, handleMarketOverviewExpandOnclick, expandScripOverviewModel, setExpandScripOverviewModel, marketDepth, selectedTab, chartOpened, setSelectedTab, setActiveButtonToggleIndex, chartURL, handleClose,
}) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
    //Prachi Tawde 02-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
    const isIndicesOverview = useSelector(state => state.indices.isIndicesOverview);
    const indicesFutureData = useSelector(state => state?.indices?.indicesFutureData);
    const arrFutureTabData = useSelector(state => state?.marketOverview?.arrFutureTabData);
    const [arrFilteredData, setArrFilteredData] = useState([]);
    const [isMarketMovement, setIsMarketMovement] = useState(false);
    //MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info -events - Start
    const hotPursuitData = useSelector(state => state?.news?.hotPursuitData);
    const bIsSectorWiseNewsDetailsApiPending = useSelector(state => state?.news?.bIsSectorWiseNewsDetailsApiPending);

    const isHotPursuitAPIFailed = useSelector(state => state?.news?.isHotPursuitAPIFailed);
    //MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info -events - End    
    //Vaibhav Singh: BT-116978 : Fixed classifying future data based on exchange
    useEffect(() => {
        if (arrFutureTabData) {
            let arrFutureData = [];
            arrFutureTabData.forEach((each) => {
                if (each?.sExchange === scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]) {
                    arrFutureData.push(each);
                }
            });
            setArrFilteredData(arrFutureData);
        }
    }, [arrFutureTabData]);
    useEffect(() => {
        return () => {
            dispatch(resetMarketOverview());
            //Prachi Tawde 02-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
            dispatch(resetIndiceOverView());
        };
    }, [dispatch]);
    // Vaibhav Singh: 28-11-23: BT-109073: Removed Rendering of Elements:Start
    // Vaibhav Singh: 28-11-23: BT-109073: Removed Rendering of Elements:End
    useEffect(() => {
        if (scripOverviewData?.length > 0) {
            dispatch(getExchangeWiseScripInfo(scripOverviewData));
        } else { }
    }, [dispatch, scripOverviewData]);

    //Prachi Tawde 02-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
    useEffect(() => {
        // Removed older condition about future tab so that redux can be properly updated for usage in other places without user having to click Futures tab first
        if (isIndicesOverview && indicesFutureData === null) {
            dispatch(getIndiceFutureData({ nToken: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN] }));
        } else { }
    }, [dispatch, indicesFutureData, isIndicesOverview, scripOverviewData]);
    //Prachi Tawde 02-08-2023 BT-104813 Breeze - Dashboard - Indices - End


    /* BT-109096 -- Shuaib.P emptying redux state related option chain --start */
    useEffect(() => {
        return () => {
            dispatch(clearOptionChainData());
        };
    }, [dispatch]);
    /* BT-109096 -- Shuaib.P emptying redux state related option chain --end */

    //MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info -events - Start   
    const page = '1';
    const pageSize = "100";
    const jtenantToken = 1;
    const recordSize = '100';

    const boardMeetings = useSelector(state => state?.events?.boardMeeting);
    const bookClosures = useSelector(state => state?.events?.bookClosure);
    const split = useSelector(state => state?.events?.split);
    const bonus = useSelector(state => state?.events?.bonus);
    const dividend = useSelector(state => state?.events?.dividend);
    const rights = useSelector(state => state?.events?.rights);
    const agm = useSelector(state => state?.events?.agm);
    const egm = useSelector(state => state?.events?.egm);
    const buy_back = useSelector(state => state?.events?.buy_back);


    const [detailedEvent, setDetailedEvent] = useState();
    const [legDataForMultilegOrder, setLegDataForMultilegOrder] = useState([]);

    const handleEventsDetails = (event) => {
        setDetailedEvent(event);
        dispatch(handleModal([{ "CORPORATE_ACTIONS_DETAILS": true }]));
    };
    //MAhesh S: 26-10-23 :BT-107375 - Breeze - Scrip info events upcoming events changes- Start
    const arrCorporateActionTypes = useMemo(() => [
        {
            id: 1,
            Title: 'Board Meeting',
            type: 'board_meeting',
            label: 'Board Meeting',
            data: boardMeetings?.length > 0 ? boardMeetings?.reverse() : [],
            isUpcomming: (boardMeetings?.length > 0 ? boardMeetings?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 2,
            Title: 'Book Closure',
            type: 'book_closure',
            label: 'Book Closure',
            data: bookClosures?.length > 0 ? bookClosures?.reverse() : [],
            isUpcomming: (bookClosures?.length > 0 ? bookClosures?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 3,
            Title: 'AGM',
            type: 'agm',
            label: 'AGM',
            data: agm?.length > 0 ? agm?.reverse() : [],
            isUpcomming: (agm?.length > 0 ? agm?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 4,
            Title: 'EGM',
            type: 'egm',
            label: 'EGM',
            data: egm?.length > 0 ? egm?.reverse() : [],
            isUpcomming: (egm?.length > 0 ? egm?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 5,
            Title: 'Split',
            type: 'split',
            label: 'Split Announced',
            data: split?.length > 0 ? split?.reverse() : [],
            isUpcomming: (split?.length > 0 ? split?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 6,
            Title: 'Dividend',
            type: 'dividend',
            label: 'Dividend Declared',
            data: dividend?.length > 0 ? dividend?.reverse() : [],
            isUpcomming: (dividend?.length > 0 ? dividend?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 7,
            Title: 'Buy Back',
            type: 'buy_back',
            label: 'Buy Back',
            data: buy_back?.length > 0 ? buy_back?.reverse() : [],
            isUpcomming: (buy_back?.length > 0 ? buy_back?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 8,
            Title: 'Rights',
            type: 'rights',
            label: 'Rights',
            data: rights?.length > 0 ? rights?.reverse() : [],
            isUpcomming: (rights?.length > 0 ? rights?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 9,
            Title: 'Bonus',
            type: 'bonus',
            label: 'Bonus',
            data: bonus?.length > 0 ? bonus?.reverse() : [],
            isUpcomming: (bonus?.length > 0 ? bonus?.some((each) => each?.Upcoming === true) : false),
        },
    ], [boardMeetings, bookClosures, bonus, rights, buy_back, dividend, split, egm, agm]);

    useEffect(() => {
        if (selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.EVENTS) {
            dispatch(scripWiseNewsData(scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripNewsPage, jtenantToken));
            dispatch(boardMeeting(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], '-', '-', page, pageSize, jtenantToken));
            dispatch(bookClosure(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], jtenantToken));
            dispatch(getAgmEgmData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], 'AGM', '-', '-', page, pageSize, jtenantToken));
            dispatch(getAgmEgmData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], 'EGM', '-', '-', page, pageSize, jtenantToken));
            dispatch(splitData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], recordSize, '-', '-', page, pageSize, jtenantToken));
            dispatch(dividendData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], recordSize, '-', '-', page, pageSize, jtenantToken));
            dispatch(buyBackData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], jtenantToken));
            dispatch(rightsData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], jtenantToken));
            dispatch(bonusData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], '-', '-', page, pageSize, jtenantToken));
            if (nCorporateAction === undefined) {
                setnCorporateAction(arrCorporateActionTypes[0]);
            } else { }
        }
    }, [selectedTab, scripOverviewData]);

    //MAhesh S: 26-10-23 :BT-107375 - Breeze - Scrip info events upcoming events changes- end

    const [nCorporateAction, setnCorporateAction] = useState();
    useEffect(() => {
        if (nCorporateAction === undefined) {
            if (arrCorporateActionTypes?.length > 0) {
                setnCorporateAction(arrCorporateActionTypes[0]);
            }
        } else { }
    }, []);
    const [activeNews, setActiveNews] = useState({});
    const handleNewsDetails = (objActiveNewsData) => {
        setActiveNews(objActiveNewsData);
        dispatch(handleModal([{ "HOT_PURSUIT_DATA": true }]));
    };
    //MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info -events - End

    // const handleLegsDataForMultilegOrder = (legDataFromOptionChain) => {
    //     setLegDataForMultilegOrder(legDataFromOptionChain);
    // };
    return (
        <>
            {spinner ?
                <div className='zero-state-loader-alerts zero-state-loader-alert-lg mrgauto'>
                    <BzLoader spinner={spinner} spinnerContent={"Fetching Details"} />
                </div>
                : !chartOpened ? <>
                    {
                        // Vaibhav Singh: 28-11-23: BT-109073: Removed Rendering of Elements:Start
                        selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.OVERVIEW ?
                            <>{(isMarketMovement) ? <MarketMovement setIsMarketMovement={setIsMarketMovement} /> : (isIndicesOverview) ? <IndicesKeyStats /> : <Overview expandScripOverviewModel={expandScripOverviewModel} setActiveButtonToggleIndex={setActiveButtonToggleIndex} marketDepth={marketDepth} scripOverviewData={scripOverviewData} setIsMarketMovement={setIsMarketMovement} />}</>
                            : null
                        // Vaibhav Singh: 28-11-23: BT-109073: Removed Rendering of Elements:End
                    }
                    {
                        selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.EVENTS ?
                            <Container fluid className='p-0 mt-5'>
                                <Row className='g-0'>
                                    <Col md={6} className='pe-3'>
                                        <div className='scripoverview-fieldset'>
                                            <div className='scripoverview-legend'>NEWS &amp; ANNOUNCEMENT</div>
                                            {hotPursuitData?.length ?
                                                <div className='scripoverview-fieldset-xl'>
                                                    <div className='so-events-height mt-3'>
                                                        <div className='transparent-card-wrap'>
                                                            {hotPursuitData?.length > 0 && hotPursuitData?.map(objActiveNewsData => (
                                                                <NewsAnnouncements objActiveNewsData={objActiveNewsData} handleNewsDetails={handleNewsDetails} />
                                                            ))}</div>
                                                    </div>
                                                </div>
                                                : bIsSectorWiseNewsDetailsApiPending && (hotPursuitData?.length === 0 || hotPursuitData?.length === undefined) ?
                                                    <div className='zero-state-loader-alerts zero-state-loader-alert-lg mrgauto'>
                                                        <BzLoader spinner={bIsSectorWiseNewsDetailsApiPending} spinnerContent={"Fetching Details"} />
                                                    </div>
                                                    : bIsSectorWiseNewsDetailsApiPending === false && (isHotPursuitAPIFailed || hotPursuitData?.length === 0 || hotPursuitData?.length === undefined) ?
                                                        <div className='zero-state-alerts zero-state-alerts-xl'>
                                                            <ZeroStates subText="No Data Found" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                        </div>
                                                        : null
                                            }

                                        </div>
                                    </Col>
                                    <Col md={6} className='ps-3'>
                                        <CorporateActions scripOverviewData={scripOverviewData} handleEventsDetails={handleEventsDetails} nCorporateAction={nCorporateAction} arrCorporateActionTypes={arrCorporateActionTypes} setnCorporateAction={setnCorporateAction} />
                                    </Col>
                                </Row>
                            </Container>
                            : null
                    }
                    {
                        selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.RECOMMENDATIONS ?
                            <Row className='g-0 pb-3'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <Recommendations objLayOut={{ horizonatal: false, wrap: true }} isMarketOver={true} />
                                </Col>
                            </Row> : null
                    }
                    {
                        selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.ANALYSIS &&
                        <>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-center align-items-center'>
                                    {/* Vaibhav Singh: BT-116661: 28-08-2023: Expand button added */}
                                    <Analysis setSelectedTab={setSelectedTab} handleMarketOverviewExpandOnclick={handleMarketOverviewExpandOnclick} expandScripOverviewModel={expandScripOverviewModel} /> {/* BT-112051 Creating tabs in Scrip Overview Analysis : ManasaB : 27/06/2023  */}
                                </Col>
                            </Row>
                        </>
                    }

                    {
                        selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.FUTURES ? <Row className='g-0'>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <Future marketDepth={marketDepth} arrFutureTabData={isIndicesOverview ? indicesFutureData : arrFilteredData} expandScripOverviewModel={expandScripOverviewModel} setExpandScripOverviewModel={setExpandScripOverviewModel} />
                            </Col>
                        </Row> : null
                    }
                    {
                        selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.OPTION_CHAIN ? <Row className='g-0'>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <OptionChainGrid />
                            </Col>
                        </Row> : null
                    }
                    {
                        scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES && selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.COMPANY_INFO ?
                            <Row className='g-0 pt-3 pb-5'>
                                <Col className='px-2'>                                   
                                    <CompanyInfo handleMarketOverviewExpandOnclick={handleMarketOverviewExpandOnclick} expandScripOverviewModel={expandScripOverviewModel} />
                                </Col>
                            </Row> : selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.CONTRACT_DETAILS &&
                            <Row className='g-0 pt-3 pb-5'>
                                <Col className='px-2'>                                    
                                    <ContractDetails handleMarketOverviewExpandOnclick={handleMarketOverviewExpandOnclick} expandScripOverviewModel={expandScripOverviewModel} />
                                 </Col>
                            </Row>
                    }
                    {
                        selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.CONSTITUENTS ? 
                        <Row className='g-0 pt-3'>
                            <Col>
                                <Constituents toggleTabs={true} />                                
                            </Col>
                        </Row> : null
                    }
                </> :

                    <OverviewChart setSelectedTab={setSelectedTab} handleClose={handleClose} chartURL={chartURL} />
            }
            {/* //Mahesh s-20-11-23 - BT-107375 - Scrip Info Events -Active Newss Added - start */}
            {/* Vaibhav Singh: As Dicussed with AmirShah NEWS_DETAILS modal is replace with HOT_PURSUIT_DATA  */}
            {modals['HOT_PURSUIT_DATA'] && <NewsDetailsModal activeNews={activeNews} tab={"newsAndAnnouncement"} />}
            <CorporateActionsDetails detailedEvent={detailedEvent} nCorporateAction={nCorporateAction} arrCorporateActionTypes={arrCorporateActionTypes} />

        </>

    );
};

export default memo(MarketOverview);
